import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRIMARY_CTA } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const easeOut = [0.23, 1, 0.32, 1] as const;
const heroReassurance = ['Immediate Access', 'One-Time Payment', '7-Day Guarantee'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-stone-50" data-id="element-130" data-mp="128fnvds7g3t2">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-131" data-mp="xa4e131wttau">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} className="w-full" data-id="element-132" data-mp="sarv2te5t6dj">
          <div className="inline-block px-3 py-1 rounded-full border border-orange-500 bg-white text-blue-950 font-bold text-[10px] sm:text-sm tracking-widest whitespace-nowrap mb-4 sm:mb-6" data-id="element-133" data-mp="3d21sryrtemo9">
            DRIVING INSTRUCTOR READY
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-extrabold leading-tight mb-4 sm:mb-6 text-blue-950" data-id="element-134" data-mp="3j928hxbf86zr">
            Solve <span className="text-orange-600" data-id="element-135" data-mp="39al8ybyf2k23">Months of Driving Lesson Planning</span> in
            Just <span className="text-orange-600" data-id="element-136" data-mp="3e960lmzlrvex">5 Minutes</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: easeOut
      }} className="relative w-full max-w-[360px] sm:max-w-xl md:max-w-4xl mb-4 sm:mb-6" data-id="element-137" data-mp="30i15my76jrax">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="relative z-10 w-full h-auto drop-shadow-xl" data-id="element-138" data-mp="2qi0kd6pr3143" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: easeOut
      }} className="w-full" data-id="element-139" data-mp="2hjypl8wm14p9">
          <p className="text-sm sm:text-lg md:text-xl text-slate-800 leading-snug max-w-3xl mx-auto mb-3 sm:mb-4" data-id="element-140" data-mp="s44gvk8yvfgb">
            The Complete 6-in-1 Visual Teaching System with{' '}
            <span className="font-semibold text-blue-950" data-id="element-141" data-mp="icrnupbfmj8p">150 Ready-to-Teach Driving Lessons</span>,
            6 Complete Volumes and 5 Professional Bonus Guides — Ready to Open and Use with Your
            Students.
          </p>

          <p className="text-xs sm:text-sm font-bold tracking-widest text-blue-700 mb-5 sm:mb-7" data-id="element-142" data-mp="1ayjep6jjl22k">
            100% VISUAL · BEGINNER TO TEST-READY · READY TO TEACH
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-143" data-mp="110wqtuk9m06g">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10" data-id="element-144" data-mp="x0306tffu79v">
              {PRIMARY_CTA}
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-slate-700 mb-3" data-id="element-145" data-mp="1x9b3owgzwtag">
            {heroReassurance.map(item => <div key={item} className="flex items-center gap-1.5" data-id="element-146" data-mp="21bfu7mc5d9sv">
                <CheckCircle size={14} className="text-green-600" data-id="element-147" data-mp="269r3nvyj5iak" />
                <span className="font-medium" data-id="element-148" data-mp="2b0pmb26zqsgz">{item}</span>
              </div>)}
          </div>

          <p className="text-xs text-slate-500" data-id="element-149" data-mp="2g02kuk785nze">
            6 Complete Volumes · 150 Ready-to-Teach Lessons · 5 Professional Bonus Guides
          </p>
        </motion.div>
      </div>
    </section>;
}